module.exports = __webpack_public_path__ + "img/i_25.723dbdab.png";